export const apiRoutes = {
    quotes: '/Quotes',
    receipt: '/receipts',
    paystub:'/paystub',
    prices: '/ListPrices',
    logoUpload: '/logo/upload',
    stripe: '/CreateCheckoutSession',
    coinbase: '/CreateCharge'
}